export default "__VITE_ASSET__ChWsYs$O__"